import { Clazz, Student, Teacher, ISCollegeTeachingClazz } from 'kuaidong-model'

class Wrapper<T> {
  constructor(public value: T) {}

  map<Func extends (val: T) => any>(func: Func) {
    return func(this.value)
  }
}

function formatClass(classNo: number) {
  if (classNo > 0) {
    return `${classNo}班`
  } else {
    return ''
  }
}

const gradeInZHCN = ['一', '二', '三', '四', '五', '六', '七', '八', '九']

function formatGrade(gradeNo: number): string {
  if (gradeNo === 7) {
    return '小班'
  } else if (gradeNo === 8) {
    return '中班'
  } else if (gradeNo === 9) {
    return '大班'
  } else if (gradeNo === 10) {
    return '入学前'
  } else if (gradeNo >= 31 && gradeNo <= 33) {
    return `高${gradeInZHCN[gradeNo - 31]}`
  } else if (gradeNo >= 61 && gradeNo <= 64) {
    return `大${gradeInZHCN[gradeNo - 61]}`
  } else if (gradeNo >= 11 && gradeNo <= 19) {
    return `${gradeInZHCN[gradeNo - 11]}年级`
  } else if (gradeNo >= 71 && gradeNo <= 74) {
    return `研${gradeInZHCN[gradeNo - 71]}`
  } else if (gradeNo === 80) {
    return '博士'
  }

  return '其他年级'
}

function formatClassWithGrade(gradeNo: number, classNo: number) {
  const formattedGrade = formatGrade(gradeNo)
  if (!formattedGrade) {
    return ''
  }
  return `${formatGrade(gradeNo)}${formatClass(classNo)}`
}

export class ClazzWrapper extends Wrapper<Clazz> {
  get id() {
    return this.value.id
  }

  get name() {
    return this._showName
  }

  get _showName() {
    return this.value.note_name || this.value.name || formatClassWithGrade(this.value.grade_no, this.value.class_no)
  }

  /**
   * @deprecated
   */
  get universityName() {
    return this.enrollmentYear ? this.enrollmentYearShown + '级' + this._showName : this._showName
  }

  get teacherNames() {
    return this.value.teachers.map((t) => t.teacher_name)
  }

  get showTeacherStr() {
    return this.teacherNames.length === 0
      ? ''
      : this.teacherNames.length === 1
      ? this.teacherNames[0]
      : `${this.teacherNames[0]}等${this.teacherNames.length}位老师`
  }

  get studentAmount() {
    return this.value.student_amount === undefined ? this.value.students.length : this.value.student_amount
  }

  get collegeSubject() {
    return this.value.college
  }

  get collegeSubjectShown() {
    return this.collegeSubject ? this.collegeSubject.name : ''
  }

  get collegeMajor() {
    return this.value.major
  }

  get collegeMajorShown() {
    return this.collegeMajor ? this.collegeMajor.name : ''
  }

  get enrollmentYear() {
    return this.value.enrollment_year
  }

  get enrollmentYearShown() {
    return this.enrollmentYear ? (this.enrollmentYear!.toString().slice(2) as any) : ''
  }

  // 是否大学班级
  get isUniversityClazz() {
    return !!this.value.college
  }

  isTeaching(id?: string) {
    return typeof this.value.is_teaching === 'undefined'
      ? !!(id && this.value.teachers.map((t) => t.teacher_id).includes(id))
      : !!this.value.is_teaching
  }
}

export class UniversityTeachingClazzWrapper extends Wrapper<ISCollegeTeachingClazz> {
  get name() {
    return this.value.name
  }

  get fullName() {
    return this.value.enrollment_year ? this.value.enrollment_year.toString().slice(2) + '级' + this.name : this.name
  }
}

export class StudentWrapper extends Wrapper<Student> {
  get name() {
    return this.value.note_name || this.value.full_name || this.value.nick_name
  }

  get className() {
    return (
      this.value.clazz!.note_name ||
      this.value.clazz!.nick_name ||
      this.value.clazz!.name ||
      formatClassWithGrade(this.value.clazz!.grade_no, this.value.clazz!.class_no)
    )
  }

  get id() {
    return this.value.user_id
  }

  get gender() {
    return this.value.gender
  }

  get code() {
    return this.value.student_no || '-'
  }

  get avatar() {
    return this.value.head_img_url
  }

  get enrollmentYear() {
    return this.value.enrollment_year
  }
}

export class TeacherWrapper extends Wrapper<Teacher> {
  get avatar() {
    return this.value.head_img_url
  }

  get name() {
    return this.value.teacher_name
  }

  get id() {
    return this.value.teacher_id
  }
}
